export function tryParseHttpUrl(input: string): URL | null {
  try {
    const u = new URL(input.trim());
    if (!/^https?:$/.test(u.protocol)) return null;
    return u;
  } catch {
    return null;
  }
}

export function debounce<T extends (...args: any[]) => any>(fn: T, ms: number) {
  let t: any;
  return (...args: Parameters<T>) => {
    clearTimeout(t);
    t = setTimeout(() => fn(...args), ms);
  };
}

export type LinkPreview = {
  finalUrl: string;
  status: number;
  contentType: string;
  title?: string | null;
  description?: string | null;
  image?: string | null;
  siteName?: string | null;
  hostname: string;
};


